import get from 'lodash.get';

interface UnmapSelectionGroup {
  title: string;
  alternative: boolean;
  type: string;
  description: string;
  options: UnmapSelectionGroupOption[];
}

interface UnmapSelectionGroupOption {
  name: string;
  text: string;
}

interface SelectionGroup {
  title: string;
  alternative: boolean;
  type: string;
  description: string;
  options: SelectionGroupOption[];
}

interface SelectionGroupOption {
  text: string;
  name: string;
  id: string;
}

const SUBSCRIBE_UNMAP: UnmapSelectionGroup[] = [
  {
    title: 'Bản tin khuyến mại',
    alternative: false,
    type: 'checkbox',
    description: '',
    options: [
      {
        text: 'Bản tin khuyến mại (1 lần/tuần)',
        name: 'SUB_PROMOTION_WEEK_YES',
      },
      {
        text: 'Bản tin khuyến mại tháng (1 lần/tháng)',
        name: 'SUB_PROMOTION_MONTH_YES',
      },
      {
        text: 'Các thông tin khuyến mại và thông tin giảm giá hấp dẫn với <b>số lượng giới hạn chỉ dành riêng cho bạn</b>',
        name: 'SUB_PROMOTION_UNIQUE_YES',
      },
      {
        text: 'Khuyến mãi tri ân Khách hàng thân thiết trong chương trình Membership Loyalty',
        name: 'SUB_PROMOTION_LOYALTY_YES',
      },
    ],
  },
  {
    title: 'Bản tin công nghệ',
    alternative: false,
    type: 'checkbox',
    description: '',
    options: [
      {
        text: 'Góc công nghệ: giới thiệu các sản phẩm công nghệ mới nhất',
        name: 'SUB_NEWS_TECH_YES',
      },
      {
        text: 'Góc Gaming: tất tần tật về gaming và gamer, các giải đấu esport đỉnh cao',
        name: 'SUB_NEWS_GAME_YES',
      },
      {
        text: 'Góc thủ thuật: hướng dẫn các thủ thuật máy tính và công nghệ ứng dụng cao trong cuộc sống từ chuyên gia Phong Vũ',
        name: 'SUB_NEWS_TIPS&TRICKS_YES',
      },
    ],
  },
  {
    title: 'Thư mời tham dự event',
    alternative: false,
    type: 'checkbox',
    description: '',
    options: [
      {
        text: 'Giải đấu esport do Phong Vũ tổ chức/tài trợ',
        name: 'SUB_EVENT_ESPORT_YES',
      },
      {
        text: 'Event miễn phí trải nghiệm sản phẩm do Phong Vũ và các đối tác tổ chức tài trợ',
        name: 'SUB_EVENT_EXPERIENCE_YES',
      },
    ],
  },
];

const CONFIRM_UNSUBSCRIBE_UNMAP: UnmapSelectionGroup[] = [
  {
    title: 'Chọn lý do',
    alternative: true,
    type: 'checkbox',
    description: '',
    options: [
      {
        text: 'Thông tin gửi với tần suất quá nhiều',
        name: 'UNSUB_REASON_FREQUENTLY',
      },
      {
        text: 'Tôi bấm nhầm đăng ký nhận thông tin đó',
        name: 'UNSUB_REASON_MISTAKE',
      },
      {
        text: 'Tôi không phải là khách hàng của Phong Vũ',
        name: 'UNSUB_REASON_CUSTOMEROFPV',
      },
      {
        text: 'Lý do khác',
        name: 'UNSUB_OTHER_REASONS',
      },
    ],
  },
  {
    title:
      'Hmmm! Bạn cần thêm chút thời gian để cân nhẵc? Phong Vũ có thể liên lạc lại bạn sau:',
    description:
      'Phong Vũ rất tiếc về những trải nghiệm chưa tốt hiện tại.<br/>Chúng tôi luôn lắng nghe phản hồi để có sự phục vụ tốt nhất tới bạn',
    alternative: false,
    options: [
      {
        text: '1 tháng',
        name: 'UNSUB_1M',
      },
      {
        text: '2 tháng',
        name: 'UNSUB_2M',
      },
      {
        text: '3 tháng',
        name: 'UNSUB_3M',
      },
      {
        text: '6 tháng',
        name: 'UNSUB_6M',
      },
    ],
    type: 'radio',
  },
];

const DEFAULT_MOBIO_SUBSCRIPTION = JSON.stringify({
  SUB_PROMOTION_WEEK_YES: '3b60f0e5-b761-40d7-8986-d12e44b9227d',
  SUB_PROMOTION_MONTH_YES: '01ab55f8-c24a-4825-b5b7-9af25f68cde1',
  SUB_PROMOTION_UNIQUE_YES: '1ffac4f5-ffcf-437c-aac3-8a6a311de8b3',
  SUB_PROMOTION_LOYALTY_YES: 'f791f16c-6b6c-4539-9c63-d1afcc35e92c',
  SUB_NEWS_TECH_YES: 'e4cea947-abb8-4d42-b04e-477955e952bf',
  SUB_NEWS_GAME_YES: 'a4686880-eb0a-497f-a3d8-f7e7d71f967b',
  'SUB_NEWS_TIPS&TRICKS_YES': '8b9d99a7-4915-4795-a48c-1d37de32ce48',
  SUB_EVENT_ESPORT_YES: '4824b95b-c00a-41d5-a77c-4c4449cad257',
  SUB_EVENT_EXPERIENCE_YES: '1bd00d9c-bfb0-453e-9f2b-467e3fbff0a1',
  UNSUB_REASON_FREQUENTLY: '8bff27fd-3e2d-469a-923b-311ef5c56b48',
  UNSUB_REASON_MISTAKE: '4a61834d-b646-4f37-88e8-8f5dac1c2447',
  UNSUB_REASON_CUSTOMEROFPV: 'ecdba4f1-6a36-4e84-a323-9bfe54a4cbe4',
  UNSUB_OTHER_REASONS: '8c87b9ba-ee2a-444e-b851-431405ba7a83',
  UNSUB_1M: 'eb354daf-10dd-4a8e-8594-1b833f0e55b6',
  UNSUB_2M: '9fd5c48b-0203-49c6-8211-8376b4c378d9',
  UNSUB_3M: 'f03e69a8-86a2-4c39-bfb0-2c7cc9e62ad5',
  UNSUB_6M: '3d981201-d892-4c02-86d2-ebb1042d157a',
});

export const MOBIO_SUBSCRIPTION_MAP = JSON.parse(
  typeof window !== 'undefined'
    ? get(window, 'env.MOBIO_SUBSCRIPTION', DEFAULT_MOBIO_SUBSCRIPTION)
    : DEFAULT_MOBIO_SUBSCRIPTION,
);

function mapNameWithID(
  selectionGroup: UnmapSelectionGroup[],
): SelectionGroup[] {
  for (const group of selectionGroup) {
    group.options = group.options.map(({ name, ...rest }) => ({
      ...rest,
      name,
      id: MOBIO_SUBSCRIPTION_MAP[name],
    }));
  }
  return selectionGroup as SelectionGroup[];
}

export const SUBSCRIBE = mapNameWithID(SUBSCRIBE_UNMAP);
export const CONFIRM_UNSUBSCRIBE = mapNameWithID(CONFIRM_UNSUBSCRIBE_UNMAP);
